import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSupport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSupport"><Path d="M19.5 16.5H18.5V9.5H19.4836M19.5 16.5C20.6046 16.5 21.5 15.6046 21.5 14.5V11.5C21.5 10.3954 20.6046 9.5 19.5 9.5H19.4836M19.5 16.5C19.5 19.2614 17.2614 21.5 14.5 21.5H11.5V19.5M19.4836 9.5C19.2263 5.59098 15.9741 2.5 12 2.5C8.02588 2.5 4.7737 5.59098 4.5164 9.5M4.5164 9.5H5.5V16.5H4.5C3.39543 16.5 2.5 15.6046 2.5 14.5V11.5C2.5 10.3954 3.39543 9.5 4.5 9.5H4.5164Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSupport;
